import React from "react";
import { useNavigate } from "react-router-dom";
import login_bg from "../../assets/images/login_bg.svg"; // Adjust the path as needed
import { trackError } from "../../utils/error_tracker"; // Import the centralized error tracking function
import {PRODUCT_NAME} from "../../utils/config_mapping";

/**
 * Logout Component
 * Renders a logout screen with a message and a button to navigate back to the login page.
 * @returns {JSX.Element} The logout page UI
 */
export const Logout = () => {
    const navigate = useNavigate();

    /**
     * Handles redirection to the login page.
     * Includes error tracking for unexpected navigation issues.
     */
    const gotologin = () => {
        try {
            navigate("/login");
        } catch (error) {
            trackError("Logout - Navigation to Login", error);
        }
    };

    return (
        <>

        <div className="min-h-screen flex items-center justify-center relative">
           <div class="bg-overlay"></div>
          <div className="shape">
                    <img src={login_bg} />
          </div>
          <div className="relative z-10 container mx-auto px-4">
            <div className="flex justify-center items-center">
            </div>
            <div className="flex justify-center">
              <div className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md card-bg-fill">
                <div className="text-center mb-4">
                  <h3 className="text-primary text-3xl font-bold mb-3" dangerouslySetInnerHTML={{ __html: PRODUCT_NAME }} />
                  <h5 className="text-primary text-xl mb-4">You are logged out.</h5>
                  <p>
                  Thank you for using <span dangerouslySetInnerHTML={{ __html: PRODUCT_NAME }}></span>.
                  </p>
                </div>
                <div className="mt-1">
                  <form>
                    <div className="flex justify-center items-center">
                    <button
                        className="btn btn-primary w-100"
                        onClick={gotologin}
                        >
                            Go to login
                        </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>


            {/*
            <div className="auth-page-wrapper pt-5">
                <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
                    <div className="bg-overlay"></div>
                    <div className="shape">
                        <img src={login_bg} alt="Background" />
                    </div>

                    <div className="auth-page-content">
                        <div className="container">
                        <div className="row">
                    <div className="col-lg-12">
                        
                    </div>
                </div>

                            <div className="row justify-content-center">
                                <div className="col-md-8 col-lg-6 col-xl-5">
                                    <div className="card mt-4 card-bg-fill">
                                        <div className="card-body p-4">
                                            <div className="text-center mt-2">
                                            <h3 className="text-primary mb-3" dangerouslySetInnerHTML={{ __html: PRODUCT_NAME }} />
                                                <h5 className="text-primary">You are Logged Out</h5>
                                                <p className="text-muted mt-3">
                                                    Thank you for using <span dangerouslySetInnerHTML={{ __html: PRODUCT_NAME }}></span>.
                                                </p>
                                            </div>
                                            <div className="p-2 mt-4">
                                                <div className="mt-4">
                                                    <button
                                                        className="btn btn-primary w-100"
                                                        onClick={gotologin}
                                                    >
                                                        Go to login
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            */}
        </>
    );
};
